const EmptyLayout = ({
  title,
  subTitle,
  buttonText,
  image,
  handleOnClick,
  shouldShowButton = true,
}) => (
  <div className="text-center p-6">
    <div className="icon mb-6">
      <img src={image} className="mx-auto w-[84px]" alt="empty-layout" />
    </div>
    <h1 className="text-3xl font-bold text-white mb-4">{title}</h1>
    <p className="text-base text-gray-200 mb-6">{subTitle}</p>
    <div className="inline-block">
      {shouldShowButton && (
        <button
          className="btn bg-indigo-100 text-indigo-700 hover:bg-indigo-200 focus:bg-indigo-100"
          onClick={handleOnClick}
        >
          {buttonText}
        </button>
      )}
    </div>
  </div>
);

export default EmptyLayout;
